export const UserConfirmed = Object.freeze({
    N: Symbol('0'),
    Y: Symbol('1'),
});

/**
 * Results of this method can be used in <v-select> fields.
 */
export function getItems(value = 'value', text = 'text') {
    let items = [];
    const statuses = Object.getOwnPropertyNames(UserConfirmed);

    for (const status of statuses) {
        items.push({[value]: status, [text]: getStatusText(status)});
    }

    return items;
}

export function getStatusText(status) {
    return {
        [UserConfirmed.N]: 'Nie',
        [UserConfirmed.Y]: 'Tak',
    }[UserConfirmed[status]];
}
